import React from "react";
import {
    Box,
    Stack,
    Skeleton,
    Divider,
} from "@mui/material";

export default function ListCardSkeleton() {
    return (
        <Box
            sx={{
                width: "100%",
                minWidth: 330,
            }}
        >
            {/* Folder Body */}
            <Box
                sx={{
                    position: "relative",
                    backgroundColor: "#F8FAFC",
                    border: "1px solid #E2E8F0",
                    borderRadius: 1,
                    p: 2,
                    overflow: "hidden",

                    // Top blue line
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "3px",
                        backgroundColor: "#E2E8F0",
                    },
                }}
            >
                {/* TOP */}
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                >
                    <Box>
                        {/* List Name */}
                        <Skeleton
                            variant="text"
                            width={150}
                            height={25}
                            sx={{
                                fontSize: 16,
                                transform: "none",
                            }}
                        />

                        {/* Date */}
                        <Skeleton
                            variant="text"
                            width={100}
                            height={18}
                            sx={{
                                fontSize: 11,
                                transform: "none",
                                mt: 0.2,
                            }}
                        />
                    </Box>

                    {/* MENU BUTTON */}
                    <Skeleton
                        variant="rounded"
                        width={32}
                        height={32}
                        sx={{
                            borderRadius: 1,
                        }}
                    />
                </Stack>

                <Divider sx={{ my: 1.5 }} />

                {/* BOTTOM */}
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    {/* Items */}
                    <Skeleton
                        variant="text"
                        width={75}
                        height={20}
                        sx={{
                            fontSize: 12,
                            transform: "none",
                        }}
                    />

                    {/* Remarks Chip */}
                    <Skeleton
                        variant="rounded"
                        width={65}
                        height={22}
                        sx={{
                            borderRadius: 1,
                        }}
                    />
                </Stack>
            </Box>
        </Box>
    );
}